export enum FeatureFlagName {
  DATA_EXPORT = 'DATA_EXPORT',
  EXPORT_V3 = 'EXPORT_V3',
  STONLY_KB = 'STONLY_KB',
  VONAGE_WHATSAPP_SERVICE = 'VONAGE_WHATSAPP_SERVICE',
  ENGAGE_ATTACHMENT = 'ENGAGE_ATTACHMENT',
  CASE_INTERFACE_REDESIGN = 'CASE_INTERFACE_REDESIGN',
  AI_SUMMARIZE = 'AI_SUMMARIZE',
  KEYCLOAK_AUTHENTICATION_DELEGATION = 'KEYCLOAK_AUTHENTICATION_DELEGATION',
}
